import React, { Suspense } from 'react';
import MyAnalytics from '../components/me/analytics/MyAnalytics';
import Container from '../components/shared/container/Container';
import CommonLoader from '../components/shared/loaders/CommonLoader';
import PageContainer from '../components/shared/page/PageContainer';
import PageTitle from '../components/shared/page/PageTitle';
import PageTitleContainer from '../components/shared/page/PageTitleContainer';

const Analytics = () => {
  return (
    <Suspense fallback={<CommonLoader />}>
      <section>
        <PageTitleContainer>
          <PageTitle title={'Аналітика'} />
        </PageTitleContainer>
        <PageContainer>
          <Container>
            <MyAnalytics />
          </Container>
        </PageContainer>
      </section>
    </Suspense>
  );
};

export default Analytics;
